import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {NotificationReportGrid} from "./notification_grid";
import {getUserNotifications} from "../../../services/notification/notification";

export function NotificationGridForm({userId, open, setOpen}) {

  const [notifications, setNotifications] = useState([])

  const handleOpen = () => setOpen(!open);

  async function getData() {
    const result = await getUserNotifications(userId);
    if (result.status === 200) {
      const {notificationList} = result.data;
      setNotifications(notificationList || []);
    }
  }

  useEffect(() => {
    getData()
  }, [userId]);

  return (
    <>
      <Dialog open={open} handler={handleOpen} size="xl"
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">
          <NotificationReportGrid notifications={notifications}/>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}